(function () {
  function initReveal(root = document) {
    const els = Array.from(root.querySelectorAll('[data-reveal]'));
    if (!('IntersectionObserver' in window) || !els.length) {
      // fallback simples
      els.forEach(el => el.classList.add('in-view'));
      return;
    }

    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          // Para reanimar sempre que sair/entrar, comente a linha abaixo:
          obs.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -10% 0px', // dispara um tico antes do final da viewport
      threshold: 0.15
    });

    els.forEach(el => io.observe(el));
  }

  // inicializa no carregamento normal
  document.addEventListener('DOMContentLoaded', () => initReveal(document));

  // re-inicializa ao inserir/editar sections no Theme Editor
  document.addEventListener('shopify:section:load', (e) => initReveal(e.target));
  document.addEventListener('shopify:section:select', (e) => initReveal(e.target));
})();
